<template>
    <div>
        <nav v-if="!isLoginPage" class="navbar navbar-expand-lg navbar-dark bg-success">
            <div class="container-fluid d-flex align-items-center justify-content-between">
                <a class="navbar-brand" href="#">Modul Rekam Medis</a>
                <UserDropDown />
            </div>
        </nav>
        <!-- <OldNavbar v-if="!isLoginPage" /> -->
        <NavigationMenu v-if="!isLoginPage" />
        <div class="container-fluid">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import OldNavbar from '../layouts/OldNavbar.vue';
import NavigationMenu from '../layouts/NavigationMenu.vue';
import UserDropDown from '../global/UserDropDown.vue';

export default {
    components: {
        NavigationMenu,
        UserDropDown
    },
    computed: {
        ...mapState({
            access_token: state => state.access_token,
            user: state => state.user,
        })
    },
    data() {
        return {
            isLoginPage: false
        }
    },
    created() {
        if (this.$route.path === '/login') {
            this.isLoginPage = true;
        } else {
            if (!this.access_token) {
                location.href = '/login'
            }
        }
    },
    methods: {
        logout() {
            const uri = '/api/logout'

            this.axios.post(uri, {headers: {
                'Authorization': 'Bearer '+ this.access_token
            }}).then(response => {
                if (response.data.status == 'success') {
                    const payload = {
                        auth_status: false,
                        access_token: null,
                        user: []
                    }
                    this.$store.commit('setAuth', payload)
                    location.href = '/login'
                } else {
                    this.$swal.fire({
                        title: 'Error!',
                        text: 'Username atau Password salah',
                        icon: 'error',
                        confirmButtonText: 'OK'
                    })
                }
            })
        }
    }
}
</script>
